import { Input, Upload } from 'antd';
import { FC, useState } from 'react';
import { CloseNewCountryIcon, DeleteIcon, UploadIcon } from '../../../../assets/images/countryList';
import { TAny } from '../../../../types/blog';
import { ICountryDetail, INewCountryForm } from '../../../../types/countries';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import './newCountry.scss';

interface INewCountry {
  className?: string;
  handleNewCountry?: (data: TAny) => void;
  availableList?: TAny;
  registerList?: ICountryDetail[];
  closeNewCountry?: () => void;
}

const NewCountry: FC<INewCountry> = ({
  className,
  handleNewCountry,
  availableList,
  registerList,
  closeNewCountry
}: INewCountry) => {
  const [dataNewCountry, setDataNewCountry] = useState<INewCountryForm>();
  const [errorCountry, setErrorCountry] = useState<string>();
  const getMyFile = (e: TAny) => {
    const extension = e?.name.substring(e?.name.lastIndexOf('.')).toLowerCase();
    if (extension === '.png') {
      setDataNewCountry({ ...dataNewCountry, ...{ flag: e } });
    } else {
      displayErrorNotification({ customJSXMessage: <>solo puedes subir archivos PNG</> });
    }
  };

  const verifyISOCode = (code?: string) => {
    if (code) {
      const ISOCode = availableList[code];
      if (ISOCode) {
        setDataNewCountry({ ...dataNewCountry, ...{ name: ISOCode } });
        return true;
      }
      return false;
    }
    return false;
  };

  const verifyRegisterCountries = (code?: string) => {
    if (code) {
      if (registerList && registerList?.length > 0) {
        const existCode = registerList.find(element => element.code === code);
        if (existCode) {
          return false;
        }
        return true;
      }
      return true;
    }
    return true;
  };

  const openCountryCard = () => {
    const existCode = verifyISOCode(dataNewCountry?.ISOCode || '');
    const noRegisterCode = verifyRegisterCountries(dataNewCountry?.ISOCode || '');
    setErrorCountry(!existCode ? 'Este ISO CODE no existe ' : !noRegisterCode ? 'País ya registrado' : '');
    if (handleNewCountry && existCode && noRegisterCode) {
      handleNewCountry(dataNewCountry);
    }
  };

  const verifyCountry = (code: string) => {
    if (code) {
      const ISOCode = availableList[code];
      if (ISOCode) {
        setDataNewCountry({ ...dataNewCountry, ...{ name: ISOCode }, ...{ ISOCode: code } });
      } else {
        setDataNewCountry({ ...dataNewCountry, ...{ name: '' }, ...{ ISOCode: code } });
      }
    } else {
      setDataNewCountry({ ...dataNewCountry, ...{ name: '' }, ...{ ISOCode: code } });
    }
  };

  const openLink = () => {
    window.open('https://www.datosmundial.com/codigos-de-pais.php', '_blank');
  };

  return (
    <div id="newCountry">
      <div className={`newCountryContainer ${className || ''}`}>
        <div className="boxInputNewCountry mr-16">
          <div
            className="labelNewCountry"
            style={{ color: !!errorCountry ? '#FF0000' : dataNewCountry?.ISOCode ? '#383838' : '' }}
          >
            ISO CODE
          </div>
          <Input
            onChange={e => {
              setErrorCountry(undefined);
              verifyCountry(e.target.value.toLowerCase());
            }}
            className="countryInputStyle"
            style={{
              border: !!errorCountry ? '1px solid #FF0000' : dataNewCountry?.ISOCode ? '1px solid #999999' : '',
              color: errorCountry ? '#FF0000' : ''
            }}
            placeholder="Ej. US"
          />
          {errorCountry ? (
            <div className="errorContainer">
              <div className="errorText">{errorCountry}</div>
            </div>
          ) : (
            <div className="floatLinkBox">
              <div
                className="blueText"
                onClick={() => {
                  openLink();
                }}
              >
                https://www.datosmundial.com/codigos-de-pais.php
              </div>
            </div>
          )}
        </div>
        <div className="boxInputNewCountry mr-16">
          <div className="labelNewCountry">Nombre del país </div>
          <div className="containerNameCountry">
            <div className="countryName">{dataNewCountry?.name}</div>
          </div>
        </div>
        <div className="boxFileContainer mr-16">
          <div className="labelNewCountry" style={{ color: false ? '#383838' : '' }}>
            Bandera
          </div>
          <div className="uploadItem">
            {dataNewCountry?.flag ? (
              <div
                className="myFile"
                onClick={() => {
                  setDataNewCountry({ ...dataNewCountry, ...{ flag: undefined } });
                }}
              >
                <DeleteIcon />
              </div>
            ) : (
              <Upload
                customRequest={e => {
                  getMyFile(e.file);
                }}
                showUploadList={false}
              >
                <div className="noFile">
                  <UploadIcon />
                </div>
              </Upload>
            )}
          </div>
        </div>

        <div className="boxInputNewCountry mr-16">
          <div className="labelNewCountry" style={{ color: dataNewCountry?.currencyType ? '#383838' : '' }}>
            Tipo de moneda
          </div>
          <Input
            className="countryInputStyle"
            style={{ border: dataNewCountry?.currencyType ? '1px solid #999999' : '' }}
            placeholder="Ej. USD"
            onChange={e => {
              setDataNewCountry({ ...dataNewCountry, ...{ currencyType: e.target.value } });
            }}
          />
        </div>
        <div className="boxInputNewCountry mr-48">
          <div className="labelNewCountry" style={{ color: dataNewCountry?.documentName ? '#383838' : '' }}>
            Nombre del docuemento fiscal
          </div>
          <Input
            className="countryInputStyle"
            style={{ border: dataNewCountry?.documentName ? '1px solid #999999' : '' }}
            placeholder="Ej. RFC"
            onChange={e => {
              setDataNewCountry({ ...dataNewCountry, ...{ documentName: e.target.value } });
            }}
          />
        </div>
        <div className="containerNewContryButton">
          <button
            onClick={() => {
              openCountryCard();
            }}
            disabled={
              !dataNewCountry?.ISOCode ||
              !dataNewCountry?.flag ||
              !dataNewCountry?.currencyType ||
              !dataNewCountry?.documentName ||
              !!errorCountry
            }
            className="countryButton"
          >
            Agregar país
          </button>
        </div>
        <div className="containerDeleteButton">
          <CloseNewCountryIcon
            onClick={() => {
              if (closeNewCountry) {
                closeNewCountry();
              }
            }}
            className="boxDeleteIcon"
          />
        </div>
      </div>
    </div>
  );
};

export default NewCountry;
